import React, { Component } from "react";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import Spinner from "../../../base/features/micro/Spinner";
import UploadImage from "./blocks/UploadImage";
import { shopInfo, shopsTerms } from "./services";
import { Modal, ModalBody } from "reactstrap";
import Empty from "../../../base/features/blocks/Empty";
import { CgImage } from "react-icons/cg";
import { HiOutlineArrowsExpand } from "react-icons/hi";
import { IoTrashBinOutline } from "react-icons/io5";
import "react-image-lightbox/style.css";
import Lightbox from "react-image-lightbox";
import EditCallCenter from "./blocks/EditCallCenter";
import EditShopCoordinates from "./blocks/EditShopCoordinates";
import Map from "../../map/Map";
import SimpleLabel from "../../../base/features/micro/SimpleLabel";
import Swal from "sweetalert2";
import { apiService } from "../../../base/utils/service";
import { CopyToClipboard } from "react-copy-to-clipboard";

class EditShop extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shopUid: window.location.pathname.split("/")[2],
      properties: null,
      medias: [],
      cover: {},
      selectedImage: {},
      imageModal: false,
      personalized_product: false,
      default_product_need_address: false,
      visible_product_need_address: false,
      show_on_map: false,
      isMap: window.location.pathname.includes("map") ? true : false,
      shopName: "",
      shopPhone: "",
      des: "",
      shop_uid: "",
      latitude: 35.699739,
      longitude: 51.338097,
    };
  }

  componentDidMount() {
    this.getShopProperties();
  }
  componentDidUpdate() {
    if (!window.location.pathname.includes("map") && this.state.isMap) {
      this.setState({ isMap: false });
    }
  }
  getShopProperties() {
    shopInfo(this.state.shopUid).then((items) => {
      items &&
        this.setState({
          properties: items,
          shopPhone: items.call_center,
          medias: items.medias,
          cover: items.cover,
          personalized_product: items.config.personalized_product,
          default_product_need_address:
            items.config.default_product_need_address,
          visible_product_need_address:
            items.config.visible_product_need_address,
          shopName: items.title,
          des: items.des,
          show_on_map: items.show_on_map,
          latitude: items.latitude,
          longitude: items.longitude,
          shop_uid: items.uid,
          termsModal: false,
          imageModal: false,
          selectedImage: {},
        });
    });
  }
  getTerms() {
    shopsTerms().then((items) => {
      items && this.setState({ terms: items });
    });
  }
  editShopProperties() {
    var medias = [];
    this.state.medias.map((media, i) => medias.push(media.uid));
    var params = {
      title: this.state.shopName,
      uid: this.state.shop_uid,
      des: this.state.des,
      medias: medias,
      cover: this.state.cover.uid,
      call_center: this.state.shopPhone,
      config: {
        personalized_product: this.state.personalized_product,
        default_product_need_address: this.state.default_product_need_address,
        visible_product_need_address: this.state.visible_product_need_address,
      },
      latitude: this.state.latitude,
      longitude: this.state.longitude,
      show_on_map: this.state.show_on_map,
    };
    apiService(`v1/shops/${this.state.shopUid}/info`, "put", params, true).then(
      (data) => {
        if (data && data.uid) {
          localStorage.setItem(`selected_shop`, JSON.stringify(data));
          window.location.href = `/dashboard/${data.uid}`;
        }
        if (
          data.response &&
          data.response.status &&
          data.response.status === 400 &&
          data.response.data.errors.uid
        ) {
          Swal.fire({
            text: data.response.data.errors.uid[0].message,
            showConfirmButton: false,
            toast: true,
            customClass: {
              htmlContainer: "text-center m-0",
            },
            timer: 3000,
            timerProgressBar: true,
          });
        }
      }
    );
  }
  imageRemove() {
    var new_medias = this.state.medias;
    new_medias.splice(this.state.imageIndex, 1);
    if (
      this.state.selectedImage.uid === this.state.cover.uid &&
      new_medias.length > 0
    ) {
      this.setState({ cover: new_medias[0] });
    }
    this.setState({ medias: new_medias, imageModal: false });
  }
  setImages(images) {
    if (!this.state.cover) {
      this.setState({ cover: images[0], medias: images });
    } else {
      this.setState({
        medias: images,
      });
    }
  }
  render() {
    return (
      <div className="container-fluid">
        {this.state.isMap ? (
          <Map
            coordinates={{
              latitude: this.state.latitude,
              longitude: this.state.longitude,
            }}
            isShopEdit={true}
            hideMap={(e) =>
              this.setState({
                latitude: e.latitude,
                longitude: e.longitude,
                isMap: false,
              })
            }
          />
        ) : (
          <section>
            <header
              className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
              style={{ top: "0", right: "0", left: "0", zIndex: "99999" }}
            >
              <div className="col-auto align-self-center px-0">
                <FiChevronRight
                  size="26"
                  className=""
                  onClick={() => window.history.back()}
                />
              </div>
              <div className="col text-center align-self-center px-0">
                <h1 className="fs-5 fw-bold mb-0">ویرایش فروشگاه</h1>
              </div>
              <div className="col-auto text-center align-self-center px-0">
                <button
                  onClick={() => this.editShopProperties()}
                  className="btn fs-6 p-0 fw-bold mb-0 color-main disabled-color"
                  disabled={
                    this.state.medias.length === 0 ||
                    !this.state.shopName ||
                    !this.state.shop_uid
                  }
                >
                  ذخیره
                </button>
              </div>
            </header>

            {this.state.properties ? (
              <body style={{ marginTop: "80px", marginBottom: "40px" }}>
                <div className="row mx-0">
                  <div className="col-12 px-0">
                    {this.state.medias && this.state.medias.length > 0 ? (
                      <div
                        style={{
                          height: "200px",
                          overflow: "scroll hidden",
                          whiteSpace: "nowrap",
                        }}
                        className="scrollbar-hide"
                      >
                        {this.state.medias.map((media, m) => (
                          <img
                            width="200"
                            height="200"
                            alt="shop"
                            className={
                              "rounded14 img-cover d-inline-block ms-2 " +
                              (this.state.cover &&
                                media.uid === this.state.cover.uid &&
                                "border-main")
                            }
                            src={media.file}
                            onClick={() =>
                              this.setState({
                                selectedImage: media,
                                imageModal: true,
                                imageIndex: m,
                              })
                            }
                          />
                        ))}
                      </div>
                    ) : (
                      <div
                        className="text-center my-5 text-muted fw-bold"
                        style={{
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        عکسی ثبت نشده است
                        <br />
                        جهت بررسی و تایید فروشگاه عکس فروشگاه را ثبت نمایید
                      </div>
                    )}
                  </div>
                  <UploadImage
                    images={this.state.medias}
                    updateImages={(images) => {
                      this.setImages(images);
                    }}
                  />
                  <div className="col-12 px-0 align-self-center">
                    <h2 className="d-inline-block fs-4 fw-bold ms-3 mb-0 align-bottom">
                      اطلاعات فروشگاه
                    </h2>
                  </div>
                  <div className="col-12 px-0 align-self-center mt-4 position-relative">
                    <input
                      className="form-control px-3 py-2-3 rounded14 fw-bold"
                      placeholder="نام فروشگاه"
                      value={this.state.shopName}
                      onChange={(e) =>
                        this.setState({ shopName: e.target.value })
                      }
                    />
                    {this.state.shopName && <SimpleLabel text="نام فروشگاه" />}
                  </div>
                  <div className="col-12 px-0 align-self-center mt-4 position-relative">
                    <input
                      className="form-control px-3 py-2-3 rounded14 fw-bold"
                      placeholder="شناسه فروشگاه"
                      value={this.state.shop_uid}
                      dir="ltr"
                      onChange={(e) => {
                        /^[a-zA-Z0-9_.]*$/.test(e.target.value.toString()) &&
                          this.setState({
                            shop_uid: e.target.value.toString().toLowerCase(),
                          });
                      }}
                    />
                    {this.state.shop_uid && (
                      <SimpleLabel text="شناسه فروشگاه" />
                    )}
                    <CopyToClipboard
                      text={"https://gitymarket.ir/" + this.state.shop_uid}
                      onCopy={() => {
                        Swal.fire({
                          text: "کپی شد",
                          showConfirmButton: false,
                          toast: true,
                          customClass: {
                            htmlContainer: "text-center m-0 w-auto",
                          },
                          width: 100,
                          timer: 1500,
                          timerProgressBar: true,
                        });
                      }}
                    >
                      <p className="color-main fw-bold mt-3 ms-2" dir="ltr">
                        {"https://gitymarket.ir/" + this.state.shop_uid}
                      </p>
                    </CopyToClipboard>
                    <p className="fw-bold p-3 bg-light-gray small rounded14">
                      برای شناسه فروشگاه همانند اینستاگرام فقط از حروف لاتین
                      کوچک، عدد، نقطه و زیر خط استفاده کنید
                    </p>
                  </div>
                  <div className="col-12 px-0 align-self-center mt-3 position-relative">
                    <textarea
                      rows="4"
                      className="form-control px-3 py-2-3 rounded14 fw-bold"
                      placeholder="توضیحات و درباره فروشگاه"
                      value={this.state.des}
                      onChange={(e) => this.setState({ des: e.target.value })}
                    />
                    {this.state.des && (
                      <SimpleLabel text="توضیحات و درباره فروشگاه" />
                    )}
                  </div>
                  <div className="col-12 px-0 align-self-center mt-4">
                    <div className="bg-light-gray rounded14 fs-7 fw-bolder px-3 py-2-3">
                      {"در ثبت اطلاعات فروشگاه به "}
                      <span
                        onClick={() => {
                          this.setState({ termsModal: true });
                          this.getTerms();
                        }}
                        className="color-main"
                      >
                        قوانین{" "}
                      </span>
                      {"توجه داشته باشید"}
                    </div>
                  </div>
                  <EditCallCenter
                    phone={this.state.shopPhone}
                    setPhone={(e) => this.setState({ shopPhone: e })}
                  />
                  <div className="col-12 px-0 mt-4">
                    <h2 className="fs-4 fw-bold">شخصی سازی فروشگاه</h2>
                    <div className="py-3">
                      <span className="fw-bold ms-3">محصول سفارشی</span>
                      <input
                        className="form-check-input"
                        value={this.state.personalized_product}
                        checked={this.state.personalized_product}
                        onChange={() =>
                          this.setState({
                            personalized_product:
                              !this.state.personalized_product,
                          })
                        }
                        type="checkbox"
                      />
                    </div>
                    <p className="fw-bold p-3 bg-light-gray small rounded14">
                      اگر میخواهید محصول سفارشی از سمت مشتری بپذیرید این گزینه
                      را فعال کنید
                    </p>
                    <div className="py-3">
                      <span className="fw-bold ms-3">نیاز به آدرس</span>
                      <input
                        className="form-check-input"
                        value={this.state.default_product_need_address}
                        checked={this.state.default_product_need_address}
                        onChange={() =>
                          this.setState({
                            default_product_need_address:
                              !this.state.default_product_need_address,
                          })
                        }
                        type="checkbox"
                      />
                    </div>
                    <p className="fw-bold p-3 bg-light-gray small rounded14">
                      برای محصول جدید، به صورت پیش فرض اگر به آدرس مشتری نیاز
                      دارید این گزینه را فعال کنید
                    </p>
                    <div className="py-3">
                      <span className="fw-bold ms-3">نمایش فیلد آدرس</span>
                      <input
                        className="form-check-input"
                        value={this.state.visible_product_need_address}
                        checked={this.state.visible_product_need_address}
                        onChange={() =>
                          this.setState({
                            visible_product_need_address:
                              !this.state.visible_product_need_address,
                          })
                        }
                        type="checkbox"
                      />
                    </div>
                    <p className="fw-bold p-3 bg-light-gray small rounded14">
                      در صفحه محصول، اگر میخواهید گزینه نیاز به آدرس مشتری نمایش
                      داده شود این گزینه را فعال کنید
                    </p>
                  </div>
                  <section>
                    <h2 className="fs-4 fw-bold mt-4 mb-3">مکان فروشگاه</h2>
                    <EditShopCoordinates
                      coordinates={{
                        latitude: this.state.latitude || 35.699739,
                        longitude: this.state.longitude || 51.338097,
                      }}
                      showMap={(e) => this.setState({ isMap: e })}
                    />
                  </section>
                  <div className="py-4">
                    <span className="fw-bold ms-3">نمایش مکان فروشگاه</span>
                    <input
                      className="form-check-input"
                      value={this.state.show_on_map}
                      checked={this.state.show_on_map}
                      onChange={() =>
                        this.setState({
                          show_on_map: !this.state.show_on_map,
                        })
                      }
                      type="checkbox"
                    />
                  </div>
                  <p className="fw-bold p-3 bg-light-gray small rounded14">
                    با انتخاب این گزینه مکان فروشگاه شما در اختیار کاربران قرار
                    خواهد گرفت (اگر کسب و کار خانگی هستید این گزینه را غیر فعال
                    کنید).
                  </p>
                </div>
              </body>
            ) : (
              <div className="mt-5">
                <Spinner />
              </div>
            )}
            <Modal
              dir="rtl"
              zIndex="9999999"
              className="m-0"
              contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
              isOpen={this.state.termsModal}
              toggle={() => this.setState({ termsModal: false })}
            >
              <ModalBody className="row mx-0 p-4">
                {this.state.terms ? (
                  <div className="col-12 px-0 py-2">
                    {this.state.terms.length === 0 ? (
                      <Empty text={"موردی یافت نشد"} />
                    ) : (
                      this.state.terms.map((term, t) => (
                        <div>
                          <h2 className="fw-bold fs-4">{term.title}</h2>
                          <p
                            className="fw-bold text-muted"
                            style={{
                              whiteSpace: "pre-wrap",
                              lineHeight: "1.7em",
                            }}
                          >
                            {term.des}
                          </p>
                        </div>
                      ))
                    )}
                  </div>
                ) : (
                  <Spinner />
                )}
                <button
                  onClick={() => this.setState({ termsModal: false })}
                  className="btn rounded28 py-2 w-100 fw-bold bg-color-main text-center text-white"
                >
                  متوجه شدم
                </button>
              </ModalBody>
            </Modal>
            {this.state.imageModal && this.state.selectedImage && (
              <Modal
                dir="rtl"
                zIndex="9999999"
                className="m-0"
                contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto max-h-75"
                isOpen={this.state.imageModal}
                toggle={() => this.setState({ imageModal: false })}
              >
                <ModalBody className="row mx-0 p-4">
                  {this.state.selectedImage.uid !== this.state.cover.uid && (
                    <div
                      className="row mx-0 p-3 border rounded14"
                      onClick={() =>
                        this.setState({
                          cover: this.state.selectedImage,
                          imageModal: false,
                        })
                      }
                    >
                      <div className="col-auto px-1 align-self-center">
                        <CgImage size={20} />
                      </div>
                      <div className="col px-2">
                        <p className="mb-0 fs-5 fw-bold">تنظیم به عنوان کاور</p>
                      </div>
                      <div className="col-auto px-1 align-self-center">
                        <FiChevronLeft size={24} />
                      </div>
                    </div>
                  )}
                  <div
                    className="row mx-0 p-3 border rounded14 mt-3"
                    onClick={() =>
                      this.setState({ imageModal: false, lightbox: true })
                    }
                  >
                    <div className="col-auto px-1 align-self-center">
                      <HiOutlineArrowsExpand size={20} />
                    </div>
                    <div className="col px-2">
                      <p className="mb-0 fs-5 fw-bolder">نمایش تمام صفحه</p>
                    </div>
                    <div className="col-auto px-1 align-self-center">
                      <FiChevronLeft size={24} />
                    </div>
                  </div>
                  <div
                    className="row mx-0 p-3 border border-danger text-danger rounded14 mt-3"
                    onClick={() => this.imageRemove()}
                  >
                    <div className="col-auto px-1 align-self-center">
                      <IoTrashBinOutline size={20} />
                    </div>
                    <div className="col px-2">
                      <p className="mb-0 fs-6 fw-bolder">
                        برای حذف عکس نگه دارید
                      </p>
                    </div>
                    <div className="col-auto px-1 align-self-center">
                      <FiChevronLeft size={24} />
                    </div>
                  </div>
                </ModalBody>
              </Modal>
            )}
            {this.state.lightbox && this.state.selectedImage && (
              <Lightbox
                mainSrc={this.state.selectedImage.file}
                onCloseRequest={() => this.setState({ lightbox: false })}
                reactModalStyle={{
                  overlay: {
                    zIndex: "100000000",
                  },
                  content: {
                    zIndex: "100000000",
                  },
                }}
              />
            )}
          </section>
        )}
      </div>
    );
  }
}

export default EditShop;
